import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/projects-index/components/ProjectsInteractive.tsx");
